<div *ngIf="issue.scanStatus === 'failed'; else infectedFiles">
  GuardDuty scan failed for this EC2 instance. Look for scan id
  <span class="strong-text">{{ issue.scanId }}</span> in the GuardDuty Malware scans on the AWS console for more
  details.
</div>

<ng-template #infectedFiles>
  <div>
    <div class="strong-text">
      {{ issue.description }}
    </div>
    <div>
      <ul id="threat-list">
        <li *ngFor="let infection of issue.infectedFiles">
          Malware Type: {{ infection.malwareType }}
          <ul id="file-list">
            <li *ngFor="let file of infection.files">
              {{ file }}
            </li>
            <li *ngIf="infection.files.length < infection.totalFileCount">
              ... and {{ infection.totalFileCount - infection.files.length }} more files
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <div class="padding-top">
      Visit <a [href]="issue.consoleLink" target="_blank">the GuardDuty console</a> for more scan details
    </div>
  </div>
</ng-template>
